import { useCallback } from 'react';
import { generatePath, useParams } from 'react-router-dom';

export const NAVIGATION_ITEMS = {
  EVENT_DETAILS: 'EVENT_DETAILS',
  PRIVACY_AND_TERMS: 'PRIVACY_AND_TERMS',
  PEOPLE: 'PEOPLE',
  SESSIONS: 'SESSIONS',
  COMPANIES: 'COMPANIES',
  DOCUMENTS: 'DOCUMENTS',
  VIDEOS: 'VIDEOS',
  MAPS: 'MAPS',
  SURVEYS: 'SURVEYS',
  WIDGET_PAGES: 'WIDGET_PAGES',
  EVENT_APP: 'EVENT_APP',
  EVENT_APP_HOME_PAGE: 'EVENT_APP_HOME_PAGE',
  EVENT_APP_SECTIONS: 'EVENT_APP_SECTIONS',
  EVENT_APP_GROUP_DISCUSSIONS: 'EVENT_APP_GROUP_DISCUSSIONS',
  EVENT_APP_DESIGN_STUDIO: 'EVENT_APP_DESIGN_STUDIO',
  EVENT_APP_ACTIVITY_FEED: 'EVENT_APP_ACTIVITY_FEED',
  EVENT_APP_BANNERS: 'EVENT_APP_BANNERS',
  EVENT_APP_SETTINGS: 'EVENT_APP_SETTINGS',
  BADGE_DESIGNER: 'BADGE_DESIGNER',
  GAMIFICATION: 'GAMIFICATION',
  AUDIENCE_RESPONSE: 'AUDIENCE_RESPONSE',
  LIVE_DISPLAY: 'LIVE_DISPLAY',
  ANNOUNCEMENTS: 'ANNOUNCEMENTS',
  ONSITE: 'ONSITE',
  ONSITE_CHECK_IN: 'ONSITE_CHECK_IN',
  ONSITE_LEAD_CAPTURE: 'ONSITE_LEAD_CAPTURE',
  MOBI_AI: 'MOBI_AI',
  INTEGRATIONS: 'INTEGRATIONS',
  NATIVE_INTEGRATIONS: 'NATIVE_INTEGRATIONS',
  NATIVE_INTEGRATIONS_SETTINGS: 'NATIVE_INTEGRATIONS_SETTINGS',
  ANALYTICS: 'ANALYTICS',
  AUDIT_LOG: 'AUDIT_LOG',
  EVENT_CONFIGURATION: 'EVENT_CONFIGURATION',
  COMMUNICATIONS: 'EVENT_COMMUNICATIONS',
  COMMUNICATIONS_EMAILS: 'COMMUNICATIONS_EMAILS',
  COMMUNICATIONS_EMAIL_CAMPAIGNS: 'COMMUNICATIONS_EMAIL_CAMPAIGNS',
  COMMUNICATIONS_SYSTEM_EMAILS: 'COMMUNICATIONS_SYSTEM_EMAILS',
  COMMUNICATIONS_EMAIL_SETTINGS: 'COMMUNICATIONS_EMAIL_SETTINGS',
  REGISTRATION: 'REGISTRATION',
  REGISTRATION_DETAILS: 'REGISTRATION_DETAILS',
  REGISTRATION_EMAILS: 'REGISTRATION_EMAILS',
  REGISTRATION_ORDERS: 'REGISTRATION_ORDERS',
  REGISTRATION_REG_FORM: 'REGISTRATION_REG_FORM',
  REGISTRATION_PROMO_CODES: 'REGISTRATION_PROMO_CODES',
  REGISTRATION_TICKETS: 'REGISTRATION_TICKETS',
  WEBSITE_BUILDER: 'WEBSITE_BUILDER',
  EMBEDDED_WIDGETS: 'EMBEDDED_WIDGETS',
  DASHBOARD: 'DASHBOARD',
};

const organizationPath = `/organization/:organizationId`;
const basepath = `${organizationPath}/event/:eventId`;

export const NAVIGATION_ROUTES = {
  [NAVIGATION_ITEMS.DASHBOARD]: {
    path: basepath,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_DETAILS]: {
    path: [`${basepath}/details`, `${basepath}/pages/details`],
    end: true,
  },
  [NAVIGATION_ITEMS.PRIVACY_AND_TERMS]: {
    path: `${basepath}/privacy`,
    end: true,
  },
  [NAVIGATION_ITEMS.PEOPLE]: {
    path: [`${basepath}/people`, `${basepath}/pages/people`],
    end: false,
  },
  [NAVIGATION_ITEMS.SESSIONS]: {
    path: [`${basepath}/sessions`, `${basepath}/pages/sessions`],
    end: false,
  },
  [NAVIGATION_ITEMS.COMPANIES]: {
    path: [`${basepath}/companies`, `${basepath}/pages/companies`],
    end: false,
  },
  [NAVIGATION_ITEMS.DOCUMENTS]: {
    path: [`${basepath}/documents`, `${basepath}/pages/documents`],
    end: true,
  },
  [NAVIGATION_ITEMS.VIDEOS]: {
    path: [`${basepath}/videos`, `${basepath}/pages/videos`],
    end: false,
  },
  [NAVIGATION_ITEMS.MAPS]: {
    path: [`${basepath}/maps`, `${basepath}/image-map`],
    end: false,
  },
  [NAVIGATION_ITEMS.SURVEYS]: {
    path: [`${basepath}/surveys`, `${basepath}/pages/surveys`],
    end: false,
  },
  [NAVIGATION_ITEMS.WIDGET_PAGES]: {
    path: `${basepath}/designer-pages`,
    end: false,
  },
  [NAVIGATION_ITEMS.EVENT_APP_HOME_PAGE]: {
    path: `${basepath}/event-app/home-page`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_APP_SECTIONS]: {
    path: `${basepath}/event-app/sections`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_APP_GROUP_DISCUSSIONS]: {
    path: `${basepath}/event-app/discussions`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_APP_DESIGN_STUDIO]: {
    path: `${basepath}/event-app/studio`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_APP_ACTIVITY_FEED]: {
    path: `${basepath}/event-app/activity-feed`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_APP_BANNERS]: {
    path: `${basepath}/event-app/banner-ads`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_APP_SETTINGS]: {
    path: `${basepath}/event-app/settings`,
    end: true,
  },
  [NAVIGATION_ITEMS.BADGE_DESIGNER]: {
    path: `${basepath}/badge-designer`,
    end: false,
  },
  [NAVIGATION_ITEMS.GAMIFICATION]: {
    path: `${basepath}/gamification`,
    end: true,
  },
  [NAVIGATION_ITEMS.AUDIENCE_RESPONSE]: {
    path: `${basepath}/ars/settings`,
    end: true,
  },
  [NAVIGATION_ITEMS.LIVE_DISPLAY]: {
    path: [`${basepath}/live-display`, `${basepath}/pages/live-display`],
    end: false,
  },
  [NAVIGATION_ITEMS.ONSITE_CHECK_IN]: {
    path: `${basepath}/onsite/check-in`,
    end: true,
  },
  [NAVIGATION_ITEMS.ONSITE]: {
    path: `${basepath}/onsite`,
    end: true,
  },
  [NAVIGATION_ITEMS.ONSITE_LEAD_CAPTURE]: {
    path: `${basepath}/onsite/lead-capture`,
    end: true,
  },
  [NAVIGATION_ITEMS.MOBI_AI]: {
    path: `${basepath}/mobi-ai`,
    end: true,
  },
  [NAVIGATION_ITEMS.COMMUNICATIONS_EMAIL_CAMPAIGNS]: {
    path: `${basepath}/communications/emails/campaigns`,
    end: true,
  },
  [NAVIGATION_ITEMS.COMMUNICATIONS_SYSTEM_EMAILS]: {
    path: `${basepath}/communications/emails/system`,
    end: true,
  },
  [NAVIGATION_ITEMS.COMMUNICATIONS_EMAIL_SETTINGS]: {
    path: `${basepath}/communications/emails/settings`,
    end: true,
  },
  [NAVIGATION_ITEMS.COMMUNICATIONS_EMAILS]: {
    path: `${basepath}/communications/emails`,
    end: false,
  },
  [NAVIGATION_ITEMS.INTEGRATIONS]: {
    path: [`${basepath}/integrations`, `${basepath}/pages/integrations`],
    end: true,
  },
  [NAVIGATION_ITEMS.NATIVE_INTEGRATIONS]: {
    path: [`${basepath}/native-integrations`],
    end: true,
  },
  [NAVIGATION_ITEMS.NATIVE_INTEGRATIONS_SETTINGS]: {
    path: [`${basepath}/native-integration-settings`],
    end: true,
  },
  [NAVIGATION_ITEMS.ANNOUNCEMENTS]: {
    path: `${basepath}/communications/announcements`,
    end: true,
  },
  [NAVIGATION_ITEMS.ANALYTICS]: {
    path: `${basepath}/analytics`,
    end: true,
  },
  [NAVIGATION_ITEMS.AUDIT_LOG]: {
    path: `${basepath}/audit-log`,
    end: true,
  },
  [NAVIGATION_ITEMS.EVENT_CONFIGURATION]: {
    path: `${basepath}/configuration`,
    end: true,
  },
  [NAVIGATION_ITEMS.REGISTRATION_DETAILS]: {
    path: `${basepath}/registration/details`,
    end: true,
  },
  [NAVIGATION_ITEMS.REGISTRATION_EMAILS]: {
    path: `${basepath}/registration/email`,
    end: true,
  },
  [NAVIGATION_ITEMS.REGISTRATION_ORDERS]: {
    path: `${basepath}/registration/orders`,
    end: false,
  },
  [NAVIGATION_ITEMS.REGISTRATION_PROMO_CODES]: {
    path: `${basepath}/registration/promo-codes`,
    end: false,
  },
  [NAVIGATION_ITEMS.REGISTRATION_REG_FORM]: {
    path: `${basepath}/registration/form`,
    end: true,
  },
  [NAVIGATION_ITEMS.REGISTRATION_TICKETS]: {
    path: `${basepath}/registration/tickets`,
    end: false,
  },
  [NAVIGATION_ITEMS.WEBSITE_BUILDER]: {
    path: `${basepath}/website-builder`,
    end: false,
  },
  [NAVIGATION_ITEMS.EMBEDDED_WIDGETS]: {
    path: `${basepath}/embedded-widgets`,
    end: false,
  },
};

export const useGetNavigationPath = () => {
  const { organizationId, eventId } = useParams();

  return useCallback(
    (key, localEventId) => {
      const firstPath = Array.isArray(NAVIGATION_ROUTES[key].path)
        ? NAVIGATION_ROUTES[key].path[0]
        : NAVIGATION_ROUTES[key].path;
      return generatePath(firstPath, { organizationId, eventId: localEventId ?? eventId });
    },
    [organizationId, eventId],
  );
};
